class FireStoreRepo{
    constructor(){
        //決定資料存的年份
        this.collection = "platform-message-bg";
        this.lastDoc = null;
        this.isFirstIn = true;
        this.unreadCount = 0;
        if(window.location.host.toLowerCase().indexOf('.ehanlin.com.tw') >= 0){
            //正式機
            this.firebaseConfig = {
                apiKey: "AIzaSyAQOYvVGa2Y8BwyES39k7InQ5RTlR59fTQ",
                authDomain: "platform-message-bg-tw.firebaseapp.com",
                projectId: "platform-message-bg-tw",
                storageBucket: "platform-message-bg-tw.appspot.com",
                messagingSenderId: "552844102282",
                appId: "1:552844102282:web:1af9d660a281c210aafb73",
                measurementId: "G-EN77JMHPG6"
            }

        }else if(window.location.host.toLowerCase().indexOf('.tbbt.com.tw') >= 0 || window.location.host.toLowerCase().indexOf('localhost') >= 0){
            //測試機
            this.firebaseConfig = {
                apiKey: "AIzaSyAXNGqzzan6mC_eSq43ywmFxd7ZCXyaQ3o",
                authDomain: "tutor-test-238709.firebaseapp.com",
                databaseURL: "https://tutor-test-238709.firebaseio.com",
                projectId: "tutor-test-238709",
                storageBucket: "tutor-test-238709.appspot.com",
                messagingSenderId: "184800465453",
                appId: "1:184800465453:web:9a81935d3a4d57e8"
            };
        }

        let fBase = firebase.initializeApp(this.firebaseConfig, "message");
        this.db = fBase.firestore();
    }

    onUpdate(userId){
        this.unreadCount = 0;
        let _this = this;
        this.db.collection(`${this.collection}`)
            .where("user", "==", userId)
            .orderBy("modifyDate",'desc')
            .onSnapshot(function (querySnapshot) {
                // let unreadCount = 0;
                if (querySnapshot) {
                    if(!_this.isFirstIn){
                        _this.unreadCount = 0;
                        let allData = [];
                        querySnapshot.docChanges().forEach((change) => {
                            if (change.type === "added") {
                                allData.push(change.doc.data());
                            }
                        });

                        updateOnUpdateMessage(allData);

                        querySnapshot.docs.forEach((doc, index, array) => {
                            if(!doc.data()["read"]){
                                _this.unreadCount++;
                            }
                        });
                        window.eHanlin.dataprovider.ehMessage.setUnreadCount();
                    }else{
                        querySnapshot.docs.forEach((doc, index, array) => {
                            if(!doc.data()["read"]){
                                _this.unreadCount++;
                            }
                        });
                    }
                }
            })
    }

    findFirstListByUser(userId, count){
        let promise = new Promise((resolve, reject) => {
            resolve(
                //get
                this.db.collection(`${this.collection}`).where("user", "==", userId).orderBy('modifyDate', 'desc').limit(count).get().then((query) => {
                    let allData = [];
                    query.forEach((doc) => {
                        // doc.data() is never undefined for query doc snapshots
                        allData.push(doc.data());
                        this.lastDoc = doc;
                    });
                    this.isFirstIn = false;
                    return allData;
                })
            )
        })
        return promise;
    }

    findFirstListByUserAndFilter(userId, count, filterTag){
        let promise = new Promise((resolve, reject) => {
            resolve(
                //get
                this.db.collection(`${this.collection}`).where("user", "==", userId).where("filterTag", "==", filterTag).orderBy('modifyDate', 'desc').limit(count).get().then((query) => {
                    let allData = [];
                    query.forEach((doc) => {
                        allData.push(doc.data());
                        this.lastDoc = doc;
                    });
                    return allData;
                })
            )
        })
        return promise;
    }

    findMoreListByUser(userId, count){
        let promise = new Promise((resolve, reject) => {
            resolve(
                //get
                this.db.collection(`${this.collection}`).where("user", "==", userId).orderBy('modifyDate', 'desc').startAfter(this.lastDoc).limit(count).get().then((query) => {
                    let allData = [];
                    query.forEach((doc) => {
                        allData.push(doc.data());
                        this.lastDoc = doc;
                    });
                    return allData;
                })
            )
        })
        return promise;
    }

    findMoreListByUserAndFilter(userId, count, filterTag){
        let promise = new Promise((resolve, reject) => {
            resolve(
                //get
                this.db.collection(`${this.collection}`).where("user", "==", userId).where('filterTag', '==', filterTag).orderBy('modifyDate', 'desc').startAfter(this.lastDoc).limit(count).get().then((query) => {
                    let allData = [];
                    query.forEach((doc) => {
                        allData.push(doc.data());
                        this.lastDoc = doc;
                    });
                    return allData;
                })
            )
        })
        return promise;
    }
}

(() => {
    const repo = new FireStoreRepo();
    const COUNT_PER_PAGE = 20;
    const isLocal = window.location.protocol.toLowerCase() == 'file:';

    const localData = (userId,filter) => {
        console.log("[LOCAL_DATA]");
        let result = [
            {
                "_id": "5b18c081e4b02cf234fd483e",
                "contentID": "NU_HPH_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1528348801741,
                "modifyDate": 1528348801741,
                "title": "試題疑義回覆",
                "content": "<p style=\"color:gray;\">你的問題：(B) 光電子為電子，應該帶負電。</p>\n<p>\n學院回覆：經過學院老師確認，此題目有誤。學院老師已將錯誤更正。謝謝！\n</p><p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HPH&volume=1&version=HG&id=5b17d6896739b00007f3dcb8#6\" target=\"_blank\">查看成績單>></a>\n</p>\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=e20b6ec60a6246dfb0e071920680b82d\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id" : "60ed453b4f503100064d33ec",
                "contentID" : "LV1",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : true,
                "enable" : true,
                "createDate": 1528348801742,
                "modifyDate": 1528348801750,
                "title" : "藥水調配完成",
                "content" : "<p data-chest-user='60ed08edf4df652e8ab5794b'>小矮人信差通知:同學你好,你於 2021.07.13 開始調配的水晶球已經完成囉!請盡速前往 <a href='https://www.ehanlin.com.tw/app/points-activity/'>保衛戰基地</a> 確認結果！</p>",
                "filterTag": "activity"
            },
            {
                "_id": "5a5ca37fe4b02cf234fd37b6",
                "contentID": "NU_HPH_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1516020607686,
                "modifyDate": 1516021889787,
                "title": "解題救援回覆",
                "content": "\n<p style=\"color:gray;\">\n你的問題：為何在導線上方為順時針？\n應如何判斷？\n謝謝\n</p>\n\n\n<p>\n  學院回覆：你在 2018/01/13 發問關於 高中物理一 的問題，老師已經完成解題並將影片上傳至課程內。\n</p>\n\n<p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&amp;subject=HPH&amp;volume=1&amp;version=HG&amp;id=5a54cb1fd0687c00069927af&amp;link=true#8\" target=\"_blank\">立即前往觀看老師的解題影片>></a>\n</p>\n\n\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=831d64e0490b416c9beddb68f0a79181\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id" : "5e8fbeced61d550006cca791",
                "contentID" : "",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1515679808040,
                "modifyDate": 1515679808090,
                "title" : "防疫再啟動",
                "content" : "<p>線上指定e名師課程79折！結帳輸入HOMESAFE立享優惠！適用課程：小中高下學期e名師、升私中課程、素養課程。 <a href='https://www.ehanlin.com.tw/app/magic/'>立即購買</a></p><img src='https://public.ehanlin.com.tw/web/eh-message/ad-picture/ad-message-covid.png' style='width:100%;display:block' alt='一張圖片'>",
                "filterTag": "hot",
            },
            {
                "_id": "5a577040e4b02cf234fd36a7",
                "contentID": "NU_HPH_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1515679808040,
                "modifyDate": 1515832895998,
                "title": "解題救援回覆",
                "content": "\n       \n      <p style=\"color:gray\">\n      你的問題：看不懂解析QQ\n      </p>\n      \n      <p>           \n      學院回覆：請觀看詳解後，具體描述清楚您的疑問點後再重新提問，如此老師才可以更清楚的為您解惑。           \n      </p>          \n      <p>           \n        <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HPH&volume=1&version=HG&id=5a54cb1fd0687c00069927af&link=true#8\" target=\"_blank\">立即前往成績單題目>></a>\n      </p>\n      <p>\n        <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=831d64e0490b416c9beddb68f0a79181\" target=\"_blank\">題目連結</a> \n      </p>\n    ",
                "filterTag": "solve"
            },
            {
                "_id" : "60ed453b4f503100064",
                "contentID" : "LV1",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1515679808040,
                "modifyDate": 1515679808045,
                "title" : "藥水調配完成",
                "content" : "<p data-chest-user='60ed08edf4df652e8ab5794b'>小矮人信差通知:同學你好,你於 2021.07.13 開始調配的水晶球已經完成囉!請盡速前往 <a href='https://www.ehanlin.com.tw/app/points-activity/'>保衛戰基地</a> 確認結果！</p>",
                "filterTag": "activity"
            },
            {
                "_id": "5a57703fe4b02cf234fd36a6",
                "contentID": "NU_HPH_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1515679807953,
                "modifyDate": 1515832296433,
                "title": "解題救援回覆",
                "content": "\n       \n      <p style=\"color:gray\">\n      你的問題：看不懂解析。。。\n      </p>\n      \n      <p>           \n      學院回覆：請觀看詳解後，具體描述清楚您的疑問點後再重新提問，如此老師才可以更清楚的為您解惑。           \n      </p>          \n      <p>           \n        <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HPH&volume=1&version=HG&id=5a54cb1fd0687c00069927af&link=true#1\" target=\"_blank\">立即前往成績單題目>></a>\n      </p>\n      <p>\n        <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=eb8015f9324c46e7a73453f8a8ea6485\" target=\"_blank\">題目連結</a> \n      </p>\n    ",
                "filterTag": "solve"
            },
            {
                "_id": "5a102ce5e4b02cf234fd2ec8",
                "contentID": "NU_HPH_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1511009509074,
                "modifyDate": 1511054941506,
                "title": "解題救援回覆",
                "content": "\n<p style=\"color:gray;\">\n你的問題：看不懂。。。。。。\n</p>\n\n\n<p>\n  學院回覆：你在 2017/11/18 發問關於 高中物理一 的問題，老師已經完成解題並將影片上傳至課程內。\n</p>\n\n<p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&amp;subject=HPH&amp;volume=1&amp;version=HG&amp;id=5a0fda9ef8abdf00080e9b06&amp;link=true#3\" target=\"_blank\">立即前往觀看老師的解題影片>></a>\n</p>\n\n\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=f318717befb842cb880a5e96e3b3ece3\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id": "59eafc3fe4b02cf234fd2bf7",
                "contentID": "NU_HCE_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1508572223369,
                "modifyDate": 1508588554041,
                "title": "解題救援回覆",
                "content": "\n<p style=\"color:gray;\">\n你的問題：如何求出丙與丁？為何乙小於16?\n</p>\n\n\n<p>\n  學院回覆：你在 2017/10/19 發問關於 高中化學一 的問題，老師已經完成解題並將影片上傳至課程內。\n</p>\n\n<p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&amp;subject=HCE&amp;volume=1&amp;version=HG&amp;id=59e8ae6885b4b900069778cb&amp;link=true#9\" target=\"_blank\">立即前往觀看老師的解題影片>></a>\n</p>\n\n\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=bce5f4decdee4709974b0fd49c659270\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id": "59e7f91de4b02cf234fd2bc4",
                "contentID": "NU_HHI_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1508374813277,
                "modifyDate": 1508422597200,
                "title": "試題疑義回覆",
                "content": "<p style=\"color:gray;\">你的問題：題目不完整\n</p>\n<p>\n學院回覆：您在 2017/10/17 發問關於 高中第一冊歷史e評量 的問題，經過學院老師確認，屬雲端系統出現問題，並已修正。謝謝您的疑義！\n</p><p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/reviewOne.html?year=106&subject=HHI&volume=1&version=HG&id=fc96b667e20a458d914a39554b203bf4\" target=\"_blank\">查看成績單>></a>\n</p>\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=fc96b667e20a458d914a39554b203bf4\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id": "59da1bf4e4b02cf234fd27d7",
                "contentID": "NU_HCE_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1507466228548,
                "modifyDate": 1507644082462,
                "title": "解題救援回覆",
                "content": "\n       \n      <p style=\"color:gray\">\n      你的問題：請問老師：工業酒精為混合物，那酒精為化合物還是混合物呢？\n      </p>\n      \n      <p>           \n      學院回覆：工業酒精會加入甲醇所以是混和物  而酒精指的是純的乙醇所以是化合物           \n      </p>          \n      <p>           \n        <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HCE&volume=1&version=HG&id=59d85dc7de602c00089787cf&link=true#8\" target=\"_blank\">立即前往成題目>></a>\n      </p>\n      <p>\n        <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=e692509d67c7442c9de563693d071bab\" target=\"_blank\">題目連結</a> \n      </p>\n    ",
                "filterTag": "solve"
            },
            {
                "_id": "59d83b72e4b02cf234fd27bb",
                "contentID": "NU_HPH_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1507343218410,
                "modifyDate": 1507350950514,
                "title": "試題疑義回覆",
                "content": "<p style=\"color:gray;\">你的問題：看不到選項</p>\n<p>\n學院回覆：您在 2017/10/04 發問關於 高中第一冊鎮麟物理 的問題，經過學院老師確認，屬雲端系統出現問題，並已修正。謝謝您的疑義！\n</p><p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HPH&volume=1&version=HG&id=59d45924de602c00088f392f#7\" target=\"_blank\">查看成績單>></a>\n</p>\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=666f525636434a6da84a8ee23051b700\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id": "59c23fdbe4b02cf234fd2563",
                "contentID": "NU_HCE_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1505902555229,
                "modifyDate": 1507087715192,
                "title": "試題疑義回覆",
                "content": "<p style=\"color:gray;\">你的問題：看不到選項</p>\n<p>\n學院回覆：您在 2017/09/16 發問關於 高中第一冊王宇化學 的問題，經過學院老師確認，屬雲端系統出現問題，並已修正。謝謝您的疑義！\n</p><p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HCE&volume=1&version=HG&id=59bcb092ba122000073298b8#2\" target=\"_blank\">查看成績單>></a>\n</p>\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=9d407390d842494fb676ef9dfade4a0a\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id": "59c23fdbe4b02cf234fd255d",
                "contentID": "NU_HCE_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1505902555127,
                "modifyDate": 1507087717788,
                "title": "試題疑義回覆",
                "content": "<p style=\"color:gray;\">你的問題：看不到選項</p>\n<p>\n學院回覆：您在 2017/09/16 發問關於 高中第一冊王宇化學 的問題，經過學院老師確認，屬雲端系統出現問題，並已修正。謝謝您的疑義！\n</p><p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HCE&volume=1&version=HG&id=59bcb092ba122000073298b8#2\" target=\"_blank\">查看成績單>></a>\n</p>\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=9d407390d842494fb676ef9dfade4a0a\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id": "59c23fdae4b02cf234fd2543",
                "contentID": "NU_HCE_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1505902554198,
                "modifyDate": 1507087707979,
                "title": "試題疑義回覆",
                "content": "<p style=\"color:gray;\">你的問題：看不到選項</p>\n<p>\n學院回覆：您在 2017/09/16 發問關於 高中第一冊王宇化學 的問題，經過學院老師確認，屬雲端系統出現問題，並已修正。謝謝您的疑義！\n</p><p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HCE&volume=1&version=HG&id=59bcb092ba122000073298b8#2\" target=\"_blank\">查看成績單>></a>\n</p>\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=9d407390d842494fb676ef9dfade4a0a\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id": "59c23fdae4b02cf234fd2540",
                "contentID": "NU_HCE_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1505902554160,
                "modifyDate": 1507087720759,
                "title": "試題疑義回覆",
                "content": "<p style=\"color:gray;\">你的問題：看不到選項</p>\n<p>\n學院回覆：您在 2017/09/16 發問關於 高中第一冊王宇化學 的問題，經過學院老師確認，屬雲端系統出現問題，並已修正。謝謝您的疑義！\n</p><p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HCE&volume=1&version=HG&id=59bcb092ba122000073298b8#2\" target=\"_blank\">查看成績單>></a>\n</p>\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=9d407390d842494fb676ef9dfade4a0a\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id": "59c23fd7e4b02cf234fd2508",
                "contentID": "NU_HCE_1_et",
                "user": "59b6826ee4b0c85e7b4539f5",
                "read": true,
                "enable": true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title": "試題疑義回覆",
                "content": "<p style=\"color:gray;\">你的問題：看不到選項</p>\n<p>\n學院回覆：您在 2017/09/16 發問關於 高中第一冊王宇化學 的問題，經過學院老師確認，屬雲端系統出現問題，並已修正。謝謝您的疑義！\n</p><p>\n  <a href=\"http://www.ehanlin.com.tw/nu_ehanlin/paper.html?year=106&subject=HCE&volume=1&version=HG&id=59bcb092ba122000073298b8#2\" target=\"_blank\">查看成績單>></a>\n</p>\n<p>\n  <a href=\"http://itembank.s3.amazonaws.com/v1/api/item.html?id=9d407390d842494fb676ef9dfade4a0a\" target=\"_blank\">題目連結</a>\n</p>",
                "filterTag": "solve"
            },
            {
                "_id" : "60ed453b4f5031000",
                "contentID" : "LV1",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "藥水調配完成",
                "content" : "<p data-chest-user='60ed08edf4df652e8ab5794b'>小矮人信差通知:同學你好,你於 2021.07.13 開始調配的水晶球已經完成囉!請盡速前往 <a href='https://www.ehanlin.com.tw/app/points-activity/'>保衛戰基地</a> 確認結果！</p>",
                "filterTag": "activity"
            },
            {
                "_id" : "60ed453b4f503100064d33ece",
                "contentID" : "LV1",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "藥水調配完成",
                "content" : "<p data-chest-user='60ed08edf4df652e8ab5794b'>小矮人信差通知:同學你好,你於 2021.07.13 開始調配的水晶球已經完成囉!請盡速前往 <a href='https://www.ehanlin.com.tw/app/points-activity/'>保衛戰基地</a> 確認結果！</p>",
                "filterTag": "activity"
            },
            {
                "_id" : "60ed453b4f503100064d33ecr",
                "contentID" : "LV1",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "藥水調配完成",
                "content" : "<p data-chest-user='60ed08edf4df652e8ab5794b'>小矮人信差通知:同學你好,你於 2021.07.13 開始調配的水晶球已經完成囉!請盡速前往 <a href='https://www.ehanlin.com.tw/app/points-activity/'>保衛戰基地</a> 確認結果！</p>",
                "filterTag": "activity"
            },
            {
                "_id" : "60ed453b4f503100064d33ec12",
                "contentID" : "LV1",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "藥水調配完成",
                "content" : "<p data-chest-user='60ed08edf4df652e8ab5794b'>小矮人信差通知:同學你好,你於 2021.07.13 開始調配的水晶球已經完成囉!請盡速前往 <a href='https://www.ehanlin.com.tw/app/points-activity/'>保衛戰基地</a> 確認結果！</p>",
                "filterTag": "activity"
            },
            {
                "_id" : "60ed453b4f503100064d33ec0",
                "contentID" : "LV1",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "藥水調配完成",
                "content" : "<p data-chest-user='60ed08edf4df652e8ab5794b'>小矮人信差通知:同學你好,你於 2021.07.13 開始調配的水晶球已經完成囉!請盡速前往 <a href='https://www.ehanlin.com.tw/app/points-activity/'>保衛戰基地</a> 確認結果！</p>",
                "filterTag": "activity"
            },
            {
                "_id" : "5e8fbeced61d550006cca79",
                "contentID" : "WEB_APP_MAGIC",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "傳奇魔法師 Albi 等你等到頭髮都白了",
                "content" : "<p>天啊！不敢相信你還沒上過雲端奇幻魔藥學課程！同學們都已經紛紛調配出厲害的寶藏了呢～不想錯過？那就趕快回來 <a href='https://www.ehanlin.com.tw/app/magic/'>魔藥學教室</a> 吧！</p>",
                "filterTag": "activity",
            },
            {
                "_id" : "5e8fbeced61d550006cca7",
                "contentID" : "",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "防疫再啟動",
                "content" : "<p>線上指定e名師課程79折！結帳輸入HOMESAFE立享優惠！適用課程：小中高下學期e名師、升私中課程、素養課程。 <a href='https://www.ehanlin.com.tw/app/magic/'>立即購買</a></p><img src='https://public.ehanlin.com.tw/web/eh-message/ad-picture/ad-message-covid.png' style='width:100%;display:block' alt='一張圖片'>",
                "filterTag": "hot",
            },
            {
                "_id" : "5e8fbeced61d550006cca",
                "contentID" : "",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "防疫再啟動",
                "content" : "<p>線上指定e名師課程79折！結帳輸入HOMESAFE立享優惠！適用課程：小中高下學期e名師、升私中課程、素養課程。 <a href='https://www.ehanlin.com.tw/app/magic/'>立即購買</a></p><img src='https://public.ehanlin.com.tw/web/eh-message/ad-picture/ad-message-covid.png' style='width:100%;display:block' alt='一張圖片'>",
                "filterTag": "hot",
            },
            {
                "_id" : "5e8fbeced61d550006cc",
                "contentID" : "",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "防疫再啟動",
                "content" : "<p>線上指定e名師課程79折！結帳輸入HOMESAFE立享優惠！適用課程：小中高下學期e名師、升私中課程、素養課程。 <a href='https://www.ehanlin.com.tw/app/magic/'>立即購買</a></p><img src='https://public.ehanlin.com.tw/web/eh-message/ad-picture/ad-message-covid.png' style='width:100%;display:block' alt='一張圖片'>",
                "filterTag": "hot",
            },
            {
                "_id" : "5e8fbeced61d550006",
                "contentID" : "",
                "user" : "59b6826ee4b0c85e7b4539f5",
                "read" : false,
                "enable" : true,
                "createDate": 1505902551299,
                "modifyDate": 1507087734000,
                "title" : "防疫再啟動",
                "content" : "<p>線上指定e名師課程79折！結帳輸入HOMESAFE立享優惠！適用課程：小中高下學期e名師、升私中課程、素養課程。 <a href='https://www.ehanlin.com.tw/app/magic/'>立即購買</a></p><img src='https://public.ehanlin.com.tw/web/eh-message/ad-picture/ad-message-covid.png' style='width:100%;display:block' alt='一張圖片'>",
                "filterTag": "hot",
            }
        ];

        if(filter!=null && filter!="all"){
            result = result.filter((item)=>{
                return item.filterTag==filter;
            })
        }

        if(result.length>COUNT_PER_PAGE){
            result = result.slice(0, COUNT_PER_PAGE);
        }

        let promise = new Promise((resolve, reject) => {
            setTimeout(() => resolve(result), 1000)
        });

        return promise;
    }

    const wwwData = (userId) => {
        // console.log("[WWW_DATA]");
        let promise = repo.findFirstListByUser(userId, COUNT_PER_PAGE);
        return promise;
    }

    const wwwDataByFilter = (userId, filter) => {
        // console.log("[WWW_DATA]");
        let promise = repo.findFirstListByUserAndFilter(userId, COUNT_PER_PAGE, filter);
        return promise;
    }

    const localUnreadCount = () => {
        updateUnreadCount(20);
    }

    const wwwUnreadCount = () => {
        updateUnreadCount(repo.unreadCount);
    }

    const localLoadNewMessages = (userId, filter) => {
        return localData(userId, filter);
    }

    const wwwLoadNewMessages = (userId, filter) => {
        let promise;
        if(filter==null){
            promise = repo.findMoreListByUser(userId, COUNT_PER_PAGE);
        }else{
            promise = repo.findMoreListByUserAndFilter(userId, COUNT_PER_PAGE, filter);
        }
        return promise;
    }

    const localUpdateReadStatus = (messageId) => {
        let result = {
            "_id":messageId,
            "contentID":"hot_message",
            "user":"614d8ea81711bf37dc117f5b",
            "read":true,
            "enable":true,
            "createDate":"2021-11-04T06:00:00.000+00:00",
            "modifyDate":"2021-11-19T06:19:13.380+00:00",
            "title":"",
            "content":"",
            "filterTag":"hot"
        }
        let promise = new Promise((resolve, reject) => {
            setTimeout(() => resolve(result), 1000)
        });
        return promise;
    }

    const wwwUpdateReadStatus = (messageId) => {
        const host = window.location.hostname;
        if(host.includes("localhost")){
            return localUpdateReadStatus(messageId);
        }
        let promise = new Promise((resolve, reject) => {
            fetch(`https://${host}/message-bg/message/updateReadStatus?id=${messageId}&read=true`,{
                method: 'PUT',
                headers: {
                    "content-type": "application/json"
                },
                })
                .then((response) => response.json())
                .then((result) => resolve(result))
                .catch(err => {
                    console.error(err);
                    alert('發生錯誤，請稍後重試');
                    reject(err);
            });
        });
        return promise;
    }

    // 開放給頁面使用的介面
    if(window.eHanlin === undefined || window.eHanlin === null){
        window.eHanlin = {}
    }

    if(window.eHanlin.dataprovider === undefined || window.eHanlin.dataprovider === null){
        window.eHanlin.dataprovider = {}
    }
    
    window.eHanlin.dataprovider.ehMessage = {
        dataFirstIn : (userId) => {
            repo.onUpdate(userId);
            return isLocal ? localData(userId) : wwwData(userId);
        },
        dataFirstPage : (userId) => {
            return isLocal ? localData(userId) : wwwData(userId);
        },
        dataByFilter : (userId, filter) => {
            return isLocal ? localData(userId, filter) : wwwDataByFilter(userId, filter);
        },
        setUnreadCount: () => {
            return isLocal ? localUnreadCount() : wwwUnreadCount();
        },
        getMoreData: (userId, filter) => {
            return isLocal ? localLoadNewMessages(userId, filter) : wwwLoadNewMessages(userId, filter);
        },
        updateReadStatus: (messageId) => {
            return isLocal ? localUpdateReadStatus(messageId) : wwwUpdateReadStatus(messageId);
        }
    }
})();

